export enum ExperimentStatus {
    Draft = "draft",
    Published = "published",
    Applied = "applied",
    Stopped = "stopped",
    Archived = "archived"
}

